import { Box, Link, Typography } from "@mui/material";
import usePageTitle from "hooks/usePageTitle";

export default function Info() {
    usePageTitle("Allgemeine Infos zur Hochzeit");

    return <Box maxWidth="1280px" sx={{ marginLeft: 'auto', marginRight: 'auto', marginTop: '1rem' }}>
        <Typography variant="h4" color="primary" mt="1rem">
            Wissenswertes rund um unsere Hochzeit
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Bald schon dürfen wir mit euch allen unsere Hochzeit feiern! Damit ihr bestmöglich darauf vorbereitet seid,
            möchten wir an dieser Stelle alle Infos sammeln, die ihr am großen Tag brauchen könntet.
        </Typography>

        <Typography variant="h4" color="primary" mt="1rem">
            Anreise
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Die Adresse des Gastwerks lautet:
        </Typography>

        <Typography mt="0.5rem">
            <Link href="https://www.gastwerk.com">Hotel Gastwerk</Link><br/>
            Beim Alten Gaswerk 3<br/>
            22761 Hamburg
        </Typography>

        <Typography mt="1rem">
            Telefon <Link href="tel:+4940890620">+49 (0)40 890 62-0</Link><br />
            Fax <Link href="fax:+49408906220">+49 (0)40 890 62-20</Link><br />
            E-Mail <Link href="mailto:info@gastwerk-hotel.de">info@gastwerk-hotel.de</Link>
        </Typography>

        <Typography variant="h5" color="primary" mt="1rem">
            Parkplätze
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Für Hotelgäste steht je nach Verfügbarkeit eine begrenzte Anzahl an Parkplätzen direkt vor dem Hotel zur Verfügung. 
            Die Parkgebühr beträgt 15 € pro Tag. Zudem befinden sich vor dem Hotel zwei Ladesäulen für Elektroautos. 
            Die Nutzung der Ladestationen ist kostenfrei, jedoch wird auch hier eine Parkgebühr von 15 € erhoben.
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Bitte gebt bei der Nutzung eines Hotelparkplatzes  euer Kennzeichen nach eurer Ankunft an der Rezeption an.
        </Typography>
        
        <Typography mt="0.5rem" textAlign="justify">
            Bitte beachtet, dass euer Pkw bei der Nutzung von umliegenden, nicht hoteleigenen Parkplätzen gegebenenfalls abgeschleppt wird.
        </Typography>

        <Typography variant="h5" color="primary" mt="1rem">
            Anreise mit dem ÖPNV
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Von der Bushaltestelle Bornkampsweg aus überquert ihr die Bahrenfelder Chaussee in Richtung Bahrenfelder Steindamm. Gastwerk-Fahnen weisen euch den Weg in die Straße Beim Alten Gaswerk.
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Von der S-Bahn-Station Bahrenfeld aus nehmt den Ausgang Richtung Hegarstraße (beim Fahrstuhl). Folgt der Hegarstraße zum Bahrenfelder Kirchenweg, auf den ihr links abbiegt. Bei der nächsten Möglichkeit biegt ihr rechts in die Gasstraße ab. Folgt dieser, bis ihr die Gastwerk-Fahnen seht und folgt diesen.
        </Typography>

        <img src="/gastwerk.png" alt="Anfahrtsbeschreibung" style={{ maxWidth: '100%', marginLeft: 'auto', marginRight: 'auto', display: 'block' }} />

        <Typography variant="h4" color="primary" mt="1rem">
            Übernachtung im Hotel Gastwerk
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Solltet ihr ein Zimmer benötigen, haben wir im Hotel Gastwerk ein Zimmerkontingent reserviert. 
            Die Zimmer können dort eigenständig und auf eigene Kosten gebucht werden. 
            Gebt bitte bei der Buchung das Stichwort <Typography color="primary" component="span">„HochzeitLinder/Scheffel“</Typography> an, damit ihr auf das reservierte Kontingent zugreifen könnt.
            Die Zimmer sind ab 15:00 Uhr bezugsfertig. Die Kosten für die Zimmer liegen bei 148,85 € inkl. Kulturtaxe für eine Person, 150,40 € für zwei Personen. 
        </Typography>

        <Typography variant="h4" color="primary" mt="1rem">
            Der Morgen danach
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Es gibt für euch die Möglichkeit am nächsten Morgen mit uns im Hotel zu frühstücken. Dies könnt ihr bei der Buchung eines Hotelzimmers mit angeben. Auch wenn ihr nicht im Hotel übernachtet könnt ihr zum Frühstück ins Hotel kommen. Bitte gebt uns dazu eine Rückmeldung über das Formular auf dieser Website. Frühstück gibt es für 26 € pro Person
        </Typography>

        <Typography variant="h4" color="primary" mt="1rem">
            Garderobe
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Für unsere Hochzeit wünschen wir uns eine festliche, aber entspannte Garderobe. 
            Ihr seid also herzlich eingeladen, euch schick zu kleiden – ganz ohne steife oder übertrieben formelle Kleidung.
            Ein elegantes Sommerkleid, ein Hemd mit Sakko oder ein schicker Anzug sind zum Beispiel wunderbar passend. 
            Wichtig ist vor allem, dass ihr euch wohlfühlt und den Tag mit uns genießen könnt.
        </Typography>

        <Typography variant="h4" color="primary" mt="1rem">
            Haustiere
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Während unserer Hochzeitsfeier sind keine Haustiere, mit Ausnahme von Assistenzhunden, erlaubt.
        </Typography>

        <Typography variant="h4" color="primary" mt="2rem">
            Das wünschen wir uns von euch
        </Typography>

        <Typography mt="0.5rem" textAlign="justify">
            Das größte Geschenk für uns ist, diesen besonderen Tag mit euch zu feiern.
            Wenn ihr uns trotzdem etwas schenken möchtet, freuen wir uns über einen kleinen Beitrag für unsere Hochzeitskasse oder unsere Hochzeitsreise 🇯🇵
        </Typography>

       <Typography variant="h4" color="primary" mt="2rem">
            Noch Fragen?
        </Typography>

        <Typography mt="0.5rem" mb="3rem" textAlign="justify">
            Ihr habt noch Fragen, die hier nicht beantwortet wurden? Wendet euch an unsere Trauzeug:innen Corinna und Henrik! 
            ihre Kontaktdaten findet ihr auf den Einladungen.
        </Typography>
    </Box>
}